import React, { useState, useEffect } from "react";
import axios from "axios";
import Navbar from "../../Header/header";
import SASidebar from "../../Dashboard/SuperAdmin/Superadmincom/SuperAdminSidebar";
import { API_LoginURL, API_BannerURL } from "../../../config";
import Swal from "sweetalert2";
import ReactPaginate from "react-paginate";
import { RotatingLines } from "react-loader-spinner";
import Select from "react-select";
import * as XLSX from "xlsx";
import "./UserMaster.css";

const initialFormState = {
  userId: 0,
  userName: "",
  roleId: 0,
  schoollId: 0,
  classId: 0,
  userLoggedinFrom: "Web",
  firstName: "",
  lastName: "",
  phoneNumber: "",
  address: "",
  userEmailId: "",
  password: "",
  profilePicture: "",
  role: "",
  isActive: true,
  userType: "",
  isEditing: false,
};

export default function UserMaster() {
  const [state, setState] = useState({
    roles: [],
    classes: [],
    users: [],
    schools: [],
    formData: { ...initialFormState },
    searchQuery: "",
    filterRole: "all",
    currentPage: 0,
    exporting: false,
    formSubmitted: false,
    fetchError: null,
    loadingUsers: false,
    loadingRoles: false,
    loadingClasses: false,
    itemsPerPage: 10,
    perPageOptions: [10, 25, 50, 100],
  });

  const [selectedSchoolFilter, setSelectedSchoolFilter] = useState("all");
  const [isViewMode, setIsViewMode] = useState(false); // Add separate view mode state

  // Helper function to update state
  const updateState = (newState) => {
    setState((prev) => ({ ...prev, ...newState }));
  };

  // Reset form to initial state
  const resetForm = () => {
    updateState({
      formData: { ...initialFormState },
      formSubmitted: false,
    });
    setIsViewMode(false);
  };

  // Get headers for API calls
  const getHeaders = () => {
    const token = localStorage.getItem("token");
    return {
      "Content-Type": "application/json",
      Authorization: token,
    };
  };

  // Fetch all required data
  useEffect(() => {
    let isMounted = true;

    const fetchInitialData = async () => {
      try {
        updateState({
          loadingUsers: true,
          loadingRoles: true,
          loadingSchools: true, // Add this
          fetchError: null,
        });

        const [users, roles, classes, schools] = await Promise.all([
          // Add schools here
          fetchUsers(),
          fetchRoles(),
          fetchClasses(),
          fetchSchools(), // Add this
        ]);

        if (!isMounted) return;

        updateState({
          users,
          roles,
          classes,
          schools, // Add this
          loadingUsers: false,
          loadingRoles: false,
          loadingClasses: false,
          loadingSchools: false, // Add this
        });
      } catch (error) {
        console.error("Error in data fetching:", error);
        if (isMounted) {
          updateState({
            fetchError: "Failed to load data. Please try again.",
            loadingUsers: false,
            loadingRoles: false,
            loadingClasses: false,
            loadingSchools: false, // Add this
          });
        }
      }
    };

    fetchInitialData();

    return () => {
      isMounted = false;
    };
  }, []);
  const fetchSchools = async () => {
    try {
      const response = await axios.get(
        `${API_LoginURL}school/SchoolMasterList`,
        {
          headers: getHeaders(),
        }
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching schools:", error);
      throw error;
    }
  };
  // API calls
  const fetchUsers = async () => {
    try {
      const response = await axios.get(`${API_LoginURL}user/UserList`, {
        headers: getHeaders(),
      });
      return response.data;
    } catch (error) {
      console.error("Error fetching users:", error);
      throw error;
    }
  };

  const fetchRoles = async () => {
    try {
      const response = await axios.get(`${API_LoginURL}Role/RoleList`, {
        headers: getHeaders(),
      });
      return response.data;
    } catch (error) {
      console.error("Error fetching roles:", error);
      throw error;
    }
  };

  const fetchClasses = async () => {
    try {
      const response = await axios.get(`${API_LoginURL}class/ClassMasterList`, {
        headers: getHeaders(),
      });
      return response.data;
    } catch (error) {
      console.error("Error fetching classes:", error);
      throw error;
    }
  };

  // Get unique schools from users data
  // const getUniqueSchools = () => {
  //     const schoolsMap = {};
  //     state.users.forEach((user) => {
  //         if (user.schoollId && user.schoolName) {
  //             schoolsMap[user.schoollId] = {
  //                 school_id: user.schoollId,
  //                 school_name: user.schoolName,
  //             };
  //         }
  //     });
  //     return Object.values(schoolsMap);
  // };

  // Form handlers
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    const updatedValue = name === "isActive" ? value === "true" : value;

    updateState({
      formData: {
        ...state.formData,
        [name]: updatedValue,
        schoollId:
          name === "userType" && value === "IS" ? 0 : state.formData.schoollId,
      },
    });
  };

  const handleSchoolChange = (selectedOption) => {
    updateState({
      formData: {
        ...state.formData,
        schoollId: selectedOption ? selectedOption.value : null,
      },
    });
  };

  const handleClassChange = (selectedOption) => {
    updateState({
      formData: {
        ...state.formData,
        classId: selectedOption ? selectedOption.value : null,
      },
    });
  };

  const handleRoleChange = (selectedOption) => {
    const selectedRole = selectedOption 
      ? state.roles.find(r => r.roleId === selectedOption.value)
      : null;
    
    const isStudent = selectedRole?.roleName === "Student";
    
    updateState({
      formData: {
        ...state.formData,
        roleId: selectedOption ? selectedOption.value : null,
        // Clear userType if role is not Student
        userType: isStudent ? state.formData.userType : "",
        // Clear classId if role is not Student
        classId: isStudent ? state.formData.classId : 0,
      },
    });
  };

  // Items per page handler
  const handlePerPageChange = (e) => {
    updateState({
      itemsPerPage: Number(e.target.value),
      currentPage: 0,
    });
  };

  // Form validation
  const validateForm = () => {
    const { formData } = state;
    const errors = {};

    if (!formData.userName) errors.userName = "Username is required";
    if (!formData.phoneNumber) errors.phoneNumber = "Phone number is required";
    if (!formData.userEmailId) errors.userEmailId = "Email is required";
    if (!formData.roleId) errors.roleId = "Role is required";
    if (formData.userId === 0 && !formData.password) {
      errors.password = "Password is required";
    }

    const isStudent =
      state.roles.find((r) => r.roleId === formData.roleId)?.roleName ===
      "Student";
    
    // Only validate userType for Student role
    if (isStudent && !formData.userType) {
      errors.userType = "User type is required for Students";
    }
    
    if (formData.userType === "SC" && !formData.schoollId) {
      errors.schoollId = "School is required for SC users";
    }

    if (isStudent && !formData.classId) {
      errors.classId = "Class is required for Students";
    }

    return {
      isValid: Object.keys(errors).length === 0,
      errors,
    };
  };

  // Form submission
  const handleFormSubmit = async (e) => {
    e.preventDefault();
    updateState({ formSubmitted: true });

    const { isValid } = validateForm();
    if (!isValid) return;

    try {
      // Prepare form data for submission
      const isStudent = state.roles.find((r) => r.roleId === state.formData.roleId)?.roleName === "Student";
      
      const submissionData = {
        ...state.formData,
        // Send empty string for userType if role is not Student
        userType: isStudent ? state.formData.userType : "",
        // Send 0 for classId if role is not Student
        classId: isStudent ? state.formData.classId : 0,
      };

      const response = await axios.post(
        `${API_LoginURL}user/SaveUpdate`,
        submissionData,
        { headers: getHeaders() }
      );

      const isSuccess = response.data.response === "SUCCESS";

      Swal.fire({
        icon: isSuccess ? "success" : "error",
        title: isSuccess ? "Success" : "Error",
        text: isSuccess ? "User saved successfully" : response.data.response,
      });

      if (isSuccess) {
        const updatedUsers = await fetchUsers();
        updateState({
          users: updatedUsers,
          formData: { ...initialFormState },
          formSubmitted: false,
        });
        document.getElementById("usercloseModalLabel").click();
      }
    } catch (error) {
      console.error("Error saving user:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Failed to save user. Please try again.",
      });
    }
  };

  // User actions
  const handleDelete = async (userId) => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    });

    if (!result.isConfirmed) return;

    try {
      await axios.post(
        `${API_LoginURL}user/DeleteUser`,
        { userId },
        { headers: getHeaders() }
      );

      updateState({
        users: state.users.filter((user) => user.userId !== userId),
      });

      Swal.fire("Deleted!", "User has been deleted.", "success");
    } catch (error) {
      console.error("Error deleting user:", error);
      Swal.fire("Error", "Failed to delete user.", "error");
    }
  };

  const handleEdit = (user) => {
    updateState({
      formData: { ...user, isEditing: true },
      formSubmitted: false,
    });
    setIsViewMode(false);
  };

  const handleView = (user) => {
    updateState({
      formData: { ...user, isEditing: false },
      formSubmitted: false,
    });
    setIsViewMode(true);
  };

  // Search and filter
  const handleSearchChange = (e) => {
    updateState({
      searchQuery: e.target.value,
      currentPage: 0,
    });
  };

  const handleFilterChange = (e) => {
    updateState({
      filterRole: e.target.value,
      currentPage: 0,
    });
  };

  // Pagination
  const handlePageChange = ({ selected }) => {
    updateState({ currentPage: selected });
  };

  // Import/Export
  const handleImport = async (event) => {
    const file = event.target.files[0];
    if (!file) {
      Swal.fire("Warning", "Please select a file to upload.", "warning");
      return;
    }

    const validExtensions = [".xlsx", ".xls", ".csv"];
    const fileExt = file.name
      .substring(file.name.lastIndexOf("."))
      .toLowerCase();
    if (!validExtensions.includes(fileExt)) {
      Swal.fire(
        "Error",
        "Please upload a valid Excel file (.xlsx, .xls, .csv)",
        "error"
      );
      return;
    }

    const formData = new FormData();
    formData.append("formFile", file);

    try {
      const response = await axios.post(
        `${API_LoginURL}User/UploadExcel`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: localStorage.getItem("token"),
          },
        }
      );

      if (response.data.response === "SUCCESS") {
        Swal.fire("Success", "Users imported successfully!", "success");
        const updatedUsers = await fetchUsers();
        updateState({ users: updatedUsers });
      } else {
        Swal.fire(
          "Error",
          response.data.message || "Failed to import users",
          "error"
        );
      }
    } catch (error) {
      console.error("Error uploading file:", error);
      Swal.fire(
        "Error",
        error.response?.data?.message || "Failed to upload file",
        "error"
      );
    } finally {
      event.target.value = "";
    }
  };

  const exportSampleTemplate = async () => {
    try {
      updateState({ exporting: true });

      const response = await axios.post(
        `${API_LoginURL}User/UserDownload`,
        {},
        {
          headers: {
            Authorization: localStorage.getItem("token"),
          },
          responseType: "blob", // Important for file downloads
        }
      );

      // Create download link
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "User_Import_Template.xlsx");
      document.body.appendChild(link);
      link.click();

      // Cleanup
      link.parentNode.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error downloading template:", error);
      Swal.fire("Error", "Failed to download template", "error");
    } finally {
      updateState({ exporting: false });
    }
  };

  // Export all users to Excel
  const exportAllUsersToExcel = async () => {
    try {
      updateState({ exporting: true });

      // Format data for Excel
      const excelData = state.users.map((user) => ({
        "User ID": user.userId,
        Username: user.userName,
        "First Name": user.firstName,
        "Last Name": user.lastName,
        "Phone Number": user.phoneNumber,
        Email: user.userEmailId,
        Role: user.role,
        School: user.schoolName || "N/A",
        Class:
          state.classes.find((c) => c.classId === user.classId)?.className ||
          "N/A",
        "User Type": user.userType,
        Status: user.isActive ? "Inactive" : "Active",
        Address: user.address,
      }));

      // Create workbook and worksheet
      const wb = XLSX.utils.book_new();
      const ws = XLSX.utils.json_to_sheet(excelData);

      // Add worksheet to workbook
      XLSX.utils.book_append_sheet(wb, ws, "All Users");

      // Generate file and download
      const fileName = `Users_Export_${
        new Date().toISOString().split("T")[0]
      }.xlsx`;
      XLSX.writeFile(wb, fileName);
    } catch (error) {
      console.error("Error exporting users:", error);
      Swal.fire("Error", "Failed to export users", "error");
    } finally {
      updateState({ exporting: false });
    }
  };

  // Filter and paginate users
  const filteredUsers = state.users.filter((user) => {
    const searchLower = state.searchQuery.toLowerCase();
    const matchesSearch =
      user.userName?.toLowerCase().includes(searchLower) ||
      user.firstName?.toLowerCase().includes(searchLower) ||
      user.lastName?.toLowerCase().includes(searchLower) ||
      user.phoneNumber?.toLowerCase().includes(searchLower);

    const matchesRole =
      state.filterRole === "all" ||
      user.role?.toLowerCase() === state.filterRole.toLowerCase();

    const matchesSchool =
      selectedSchoolFilter === "all" ||
      user.schoollId?.toString() === selectedSchoolFilter;

    return matchesSearch && matchesRole && matchesSchool;
  });

  const pageCount = Math.ceil(filteredUsers.length / state.itemsPerPage);
  const displayedUsers = filteredUsers.slice(
    state.currentPage * state.itemsPerPage,
    (state.currentPage + 1) * state.itemsPerPage
  );

  // Render loading state
  if (state.loadingUsers || state.loadingRoles || state.loadingClasses) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ height: "100vh" }}
      >
        <RotatingLines color="#007bff" width={50} />
      </div>
    );
  }

  // Render error state
  if (state.fetchError) {
    return (
      <div className="alert alert-danger text-center mt-5">
        {state.fetchError}
      </div>
    );
  }

  return (
    <div className="container-scroller">
      <Navbar />
      <div className="container-fluid page-body-wrapper">
        <SASidebar />
        <div className="main-panel">
          <div className="content-wrapper">
            <div className="col-lg-12 grid-margin stretch-card">
              <div className="card">
                <div className="card-body">
                  {/* Header Section */}
                  <div className="d-flex flex-column flex-md-row justify-content-between align-items-center mb-4">
                    <h4 className="card-title mb-3 mb-md-0">User Master</h4>
                    <div className="d-flex flex-column flex-md-row align-items-center w-100 w-md-auto gap-2">
                      {/* Items Per Page Dropdown */}
                      <div className="me-md-2" style={{ minWidth: "120px" }}>
                        <select
                          className="form-select form-select-sm"
                          value={state.itemsPerPage}
                          onChange={handlePerPageChange}
                        >
                          {state.perPageOptions.map((option) => (
                            <option key={option} value={option}>
                              {option} per page
                            </option>
                          ))}
                        </select>
                      </div>

                      {/* School Filter Dropdown */}
                      <div className="me-md-2" style={{ minWidth: "150px" }}>
                        <Select
                          options={[
                            {
                              value: "all",
                              label: "All Schools",
                            },
                            ...state.schools.map((school) => ({
                              value: school.school_id.toString(),
                              label: school.school_name,
                            })),
                          ]}
                          value={{
                            value: selectedSchoolFilter,
                            label:
                              selectedSchoolFilter === "all"
                                ? "All Schools"
                                : state.schools.find(
                                    (s) =>
                                      s.school_id.toString() ===
                                      selectedSchoolFilter
                                  )?.school_name || "Select School",
                          }}
                          onChange={(selected) => {
                            setSelectedSchoolFilter(
                              selected ? selected.value : "all"
                            );
                            updateState({ currentPage: 0 });
                          }}
                          classNamePrefix="select"
                          isSearchable={true}
                        />
                      </div>

                      {/* Role Filter Dropdown */}
                      <div className="me-md-2" style={{ minWidth: "150px" }}>
                        <Select
                          options={[
                            {
                              value: "all",
                              label: "All Roles",
                            },
                            ...state.roles.map((role) => ({
                              value: role.roleName,
                              label: role.roleName,
                            })),
                          ]}
                          value={{
                            value: state.filterRole,
                            label:
                              state.filterRole === "all"
                                ? "All Roles"
                                : state.filterRole,
                          }}
                          onChange={(selected) =>
                            handleFilterChange({
                              target: {
                                value: selected ? selected.value : "all",
                              },
                            })
                          }
                          classNamePrefix="select"
                          isSearchable={false}
                        />
                      </div>

                      {/* Search Bar */}
                      <div
                        className="flex-grow-1 me-md-2 position-relative"
                        style={{ maxWidth: "500px" }}
                      >
                        <input
                          type="text"
                          className="form-control form-control-sm ps-5 rounded-pill border-0"
                          placeholder="Search by Name, Role or Number"
                          value={state.searchQuery}
                          onChange={handleSearchChange}
                          style={{
                            height: "38px",
                            boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
                            transition: "all 0.3s ease",
                            backgroundColor: "#f8f9fa",
                          }}
                          onFocus={(e) => {
                            e.target.style.boxShadow =
                              "0 2px 12px rgba(0,0,0,0.15)";
                            e.target.style.backgroundColor = "#fff";
                          }}
                          onBlur={(e) => {
                            e.target.style.boxShadow =
                              "0 2px 8px rgba(0,0,0,0.08)";
                            e.target.style.backgroundColor = "#f8f9fa";
                          }}
                        />
                        <i className="fas fa-search position-absolute top-50 start-0 translate-middle-y ms-3 text-muted"></i>
                      </div>

                      {/* Action Buttons */}
                      <div className="d-flex gap-2">
                        <input
                          type="file"
                          id="importFileInput"
                          style={{ display: "none" }}
                          onChange={handleImport}
                          accept=".xlsx,.xls,.csv"
                        />
                        <button
                          type="button"
                          className="btn btn-sm btn-success"
                          onClick={() =>
                            document.getElementById("importFileInput").click()
                          }
                          title="Import Users"
                        >
                          <i className="fa-solid fa-file-import me-1"></i>
                          <span className="d-none d-md-inline">Import</span>
                        </button>

                        <div className="dropdown">
                          <button
                            className="btn btn-sm btn-info dropdown-toggle"
                            type="button"
                            id="exportDropdown"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                            disabled={state.exporting}
                          >
                            {state.exporting ? (
                              <>
                                <span
                                  className="spinner-border spinner-border-sm me-1"
                                  role="status"
                                ></span>
                                Exporting
                              </>
                            ) : (
                              <>
                                <i className="fa-solid fa-file-export me-1"></i>
                                <span className="d-none d-md-inline">
                                  Export
                                </span>
                              </>
                            )}
                          </button>
                          <ul
                            className="dropdown-menu"
                            aria-labelledby="exportDropdown"
                          >
                            <li>
                              <button
                                className="dropdown-item"
                                onClick={exportSampleTemplate}
                                disabled={state.exporting}
                              >
                                {state.exporting ? (
                                  <span
                                    className="spinner-border spinner-border-sm me-2"
                                    role="status"
                                  ></span>
                                ) : (
                                  <i className="fas fa-file-excel me-2"></i>
                                )}
                                Download Template
                              </button>
                            </li>
                            <li>
                              <button
                                className="dropdown-item"
                                onClick={exportAllUsersToExcel}
                                disabled={state.exporting}
                              >
                                {state.exporting ? (
                                  <span
                                    className="spinner-border spinner-border-sm me-2"
                                    role="status"
                                  ></span>
                                ) : (
                                  <i className="fas fa-download me-2"></i>
                                )}
                                Export All Data
                              </button>
                            </li>
                          </ul>
                        </div>

                        <button
                          type="button"
                          className="btn btn-sm btn-primary"
                          data-bs-toggle="modal"
                          data-bs-target="#userModal"
                          onClick={resetForm}
                          title="Add New User"
                        >
                          <i className="fas fa-plus me-1"></i>
                          <span className="d-none d-md-inline">Add User</span>
                        </button>
                      </div>
                    </div>
                  </div>

                  {/* Table Section */}
                  <div className="table-responsive">
                    <table className="table table-striped user-master-table">
                      <thead className="table-primary">
                        <tr>
                          <th className="col-id">ID</th>
                          <th className="col-username">User Name</th>
                          <th className="col-firstname">First Name</th>
                          <th className="col-lastname">Last Name</th>
                          <th className="col-phone">Phone Number</th>
                          <th className="col-role">Role</th>
                          <th className="col-school">School</th>
                          <th className="col-status">Status</th>
                          <th className="col-action">Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {displayedUsers.map((user) => (
                          <tr key={user.userId}>
                            <td className="col-id">{user.userId}</td>
                            <td className="col-username">
                              <div className="text-truncate-custom" title={user.userName}>
                                {user.userName}
                              </div>
                            </td>
                            <td className="col-firstname">
                              <div className="text-truncate-custom" title={user.firstName}>
                                {user.firstName}
                              </div>
                            </td>
                            <td className="col-lastname">
                              <div className="text-truncate-custom" title={user.lastName}>
                                {user.lastName}
                              </div>
                            </td>
                            <td className="col-phone">{user.phoneNumber}</td>
                            <td className="col-role">{user.role}</td>
                            <td className="col-school">
                              <div className="text-truncate-custom" title={
                                state.schools.find(
                                  (s) => s.school_id === user.schoollId
                                )?.school_name || "N/A"
                              }>
                                {state.schools.find(
                                  (s) => s.school_id === user.schoollId
                                )?.school_name || "N/A"}
                              </div>
                            </td>
                            <td
                              className="col-status"
                              style={{
                                color: user.isActive ? "red" : "green",
                              }}
                            >
                              {user.isActive ? "Inactive" : "Active"}
                            </td>
                            <td className="col-action">
                              <div className="d-flex gap-2">
                                <button
                                  className="btn btn-sm btn-outline-primary p-1"
                                  data-bs-toggle="modal"
                                  data-bs-target="#userModal"
                                  onClick={() => handleView(user)}
                                  title="View"
                                >
                                  <i className="fas fa-eye"></i>
                                </button>
                                <button
                                  className="btn btn-sm btn-outline-secondary p-1"
                                  data-bs-toggle="modal"
                                  data-bs-target="#userModal"
                                  onClick={() =>
                                    handleEdit({
                                      ...user,
                                      isEditing: true,
                                    })
                                  }
                                  title="Edit"
                                >
                                  <i className="fas fa-edit"></i>
                                </button>
                                <button
                                  className="btn btn-sm btn-outline-danger p-1"
                                  onClick={() => handleDelete(user.userId)}
                                  title="Delete"
                                >
                                  <i className="fas fa-trash"></i>
                                </button>
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                    {filteredUsers.length === 0 && (
                      <div className="text-center py-4">
                        No users found matching your criteria
                      </div>
                    )}

                    <ReactPaginate
                      previousLabel={"Previous"}
                      nextLabel={"Next"}
                      pageCount={pageCount}
                      onPageChange={handlePageChange}
                      containerClassName={
                        "pagination justify-content-center mt-4"
                      }
                      pageClassName={"page-item"}
                      pageLinkClassName={"page-link"}
                      previousClassName={"page-item"}
                      previousLinkClassName={"page-link"}
                      nextClassName={"page-item"}
                      nextLinkClassName={"page-link"}
                      activeClassName={"active"}
                      forcePage={state.currentPage}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* User Modal */}
      <div
        className="modal fade"
        id="userModal"
        tabIndex="-1"
        aria-labelledby="userModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="userModalLabel">
                {state.formData.userId > 0
                  ? isViewMode
                    ? "View User"
                    : "Edit User"
                  : "Add New User"}
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>

            <form onSubmit={handleFormSubmit}>
              <div
                className="modal-body"
                style={{ maxHeight: "70vh", overflowY: "auto" }}
              >
                <div className="container-fluid">
                  {/* First Row - Role, User Type, School */}
                  <div className="row g-3 mb-3">
                    <div className="col-md-6">
                      <label htmlFor="role" className="form-label required">
                        Role
                      </label>
                      <Select
                        id="role"
                        options={state.roles.map((role) => ({
                          value: role.roleId,
                          label: role.roleName,
                        }))}
                        value={
                          state.roles.find(
                            (r) => r.roleId === state.formData.roleId
                          )
                            ? {
                                value: state.formData.roleId,
                                label: state.roles.find(
                                  (r) => r.roleId === state.formData.roleId
                                ).roleName,
                              }
                            : null
                        }
                        onChange={handleRoleChange}
                        className={
                          state.formSubmitted && !state.formData.roleId
                            ? "is-invalid"
                            : ""
                        }
                        isDisabled={isViewMode}
                      />
                      {state.formSubmitted && !state.formData.roleId && (
                        <div className="invalid-feedback">Role is required</div>
                      )}
                    </div>
                    <div className="col-md-6">
                      <label htmlFor="userType" className={`form-label ${
                        state.roles.find((r) => r.roleId === state.formData.roleId)?.roleName === "Student" 
                          ? "required" 
                          : ""
                      }`}>
                        User Type
                      </label>
                      <Select
                        id="userType"
                        name="userType"
                        className={`basic-select ${
                          state.formSubmitted && !state.formData.userType &&
                          state.roles.find((r) => r.roleId === state.formData.roleId)?.roleName === "Student"
                            ? "is-invalid"
                            : ""
                        }`}
                        classNamePrefix="select"
                        value={
                          state.formData.userType
                            ? {
                                value: state.formData.userType,
                                label: state.formData.userType,
                              }
                            : null
                        }
                        onChange={(selectedOption) =>
                          handleInputChange({
                            target: {
                              name: "userType",
                              value: selectedOption ? selectedOption.value : "",
                            },
                          })
                        }
                        options={[
                          {
                            value: "SC",
                            label: "School Student",
                          },
                          {
                            value: "CS",
                            label: "Center Student",
                          },
                          {
                            value: "IS",
                            label: "Independent Student",
                          },
                        ]}
                        placeholder="Select User Type"
                        isClearable
                        required
                        isDisabled={
                          isViewMode ||
                          state.formData.userId > 0 ||
                          !(state.formData.roleId &&
                            state.roles.find(
                              (r) => r.roleId === state.formData.roleId
                            )?.roleName === "Student")
                        }
                      />
                      {state.formSubmitted && !state.formData.userType && 
                        state.roles.find((r) => r.roleId === state.formData.roleId)?.roleName === "Student" && (
                        <div className="invalid-feedback">
                          User Type is required for Students
                        </div>
                      )}
                    </div>
                  </div>

                  {/* Second Row - Class (conditional) and School */}
                  <div className="row g-3 mb-3">
                    {/* Class Selection (only for Student role) */}
                    {state.formData.roleId &&
                    state.roles.find((r) => r.roleId === state.formData.roleId)
                      ?.roleName === "Student" ? (
                      <div className="col-md-6">
                        <label htmlFor="class" className="form-label required">
                          Class
                        </label>
                        <Select
                          id="class"
                          options={state.classes.map((cls) => ({
                            value: cls.classId,
                            label: cls.className,
                          }))}
                          value={
                            state.classes.find(
                              (c) => c.classId === state.formData.classId
                            )
                              ? {
                                  value: state.formData.classId,
                                  label: state.classes.find(
                                    (c) => c.classId === state.formData.classId
                                  ).className,
                                }
                              : null
                          }
                          onChange={handleClassChange}
                          className={
                            state.formSubmitted && !state.formData.classId
                              ? "is-invalid"
                              : ""
                          }
                          isDisabled={isViewMode}
                        />
                        {state.formSubmitted && !state.formData.classId && (
                          <div className="invalid-feedback">
                            Class is required for Students
                          </div>
                        )}
                      </div>
                    ) : null}

                    <div
                      className={
                        state.formData.roleId &&
                        state.roles.find(
                          (r) => r.roleId === state.formData.roleId
                        )?.roleName === "Student"
                          ? "col-md-6"
                          : "col-md-12"
                      }
                    >
                      <label htmlFor="school" className="form-label">
                        {state.formData.userType === "SC"
                          ? "School (Required)"
                          : "School"}
                      </label>
                      <Select
                        id="school"
                        options={state.schools.map((school) => ({
                          value: school.school_id,
                          label: school.school_name,
                        }))}
                        value={
                          state.schools.find(
                            (s) => s.school_id === state.formData.schoollId
                          )
                            ? {
                                value: state.formData.schoollId,
                                label: state.schools.find(
                                  (s) =>
                                    s.school_id === state.formData.schoollId
                                ).school_name,
                              }
                            : null
                        }
                        onChange={handleSchoolChange}
                        isDisabled={isViewMode || state.formData.userType === "IS"}
                        className={
                          state.formSubmitted &&
                          state.formData.userType === "SC" &&
                          !state.formData.schoollId
                            ? "is-invalid"
                            : ""
                        }
                      />
                      {state.formSubmitted &&
                        state.formData.userType === "SC" &&
                        !state.formData.schoollId && (
                          <div className="invalid-feedback">
                            School is required for SC users
                          </div>
                        )}
                    </div>
                  </div>

                  {/* Third Row - User Name */}
                  <div className="row g-3 mb-3">
                    <div className="col-md-12">
                      <label htmlFor="userName" className="form-label required">
                        User Name
                      </label>
                      <input
                        type="text"
                        className={`form-control p-2 ${
                          state.formSubmitted && !state.formData.userName
                            ? "is-invalid"
                            : ""
                        }`}
                        id="userName"
                        name="userName"
                        value={state.formData.userName}
                        onChange={handleInputChange}
                        disabled={state.formData.userId !== 0}
                        required
                        readOnly={isViewMode}
                      />
                      {state.formSubmitted && !state.formData.userName && (
                        <div className="invalid-feedback">
                          User Name is required
                        </div>
                      )}
                    </div>
                  </div>

                  {/* Fourth Row - First and Last Name */}
                  <div className="row g-3 mb-3">
                    <div className="col-md-6">
                      <label htmlFor="firstName" className="form-label">
                        First Name
                      </label>
                      <input
                        type="text"
                        className="form-control p-2"
                        id="firstName"
                        name="firstName"
                        value={state.formData.firstName}
                        onChange={handleInputChange}
                        readOnly={isViewMode}
                      />
                    </div>
                    <div className="col-md-6">
                      <label htmlFor="lastName" className="form-label">
                        Last Name
                      </label>
                      <input
                        type="text"
                        className="form-control p-2"
                        id="lastName"
                        name="lastName"
                        value={state.formData.lastName}
                        onChange={handleInputChange}
                        readOnly={isViewMode}
                      />
                    </div>
                  </div>

                  {/* Fifth Row - Phone, Email and Password */}
                  <div className="row g-3 mb-3">
                    <div className="col-md-6">
                      <label
                        htmlFor="phoneNumber"
                        className="form-label required"
                      >
                        Phone Number
                      </label>
                      <input
                        type="text"
                        className={`form-control p-2 ${
                          state.formSubmitted && !state.formData.phoneNumber
                            ? "is-invalid"
                            : ""
                        }`}
                        id="phoneNumber"
                        name="phoneNumber"
                        value={state.formData.phoneNumber}
                        onChange={handleInputChange}
                        required
                        readOnly={isViewMode}
                      />
                      {state.formSubmitted && !state.formData.phoneNumber && (
                        <div className="invalid-feedback">
                          Phone Number is required
                        </div>
                      )}
                    </div>

                    <div className="col-md-6">
                      <label
                        htmlFor="userEmailId"
                        className="form-label required"
                      >
                        Email
                      </label>
                      <input
                        type="email"
                        className={`form-control p-2 ${
                          state.formSubmitted && !state.formData.userEmailId
                            ? "is-invalid"
                            : ""
                        }`}
                        id="userEmailId"
                        name="userEmailId"
                        value={state.formData.userEmailId}
                        onChange={handleInputChange}
                        required
                        readOnly={isViewMode}
                      />
                      {state.formSubmitted && !state.formData.userEmailId && (
                        <div className="invalid-feedback">
                          Email is required
                        </div>
                      )}
                    </div>
                  </div>
                  {/* Password Row - Only shown when adding new user or editing */}
                  {(!isViewMode || state.formData.userId === 0) && (
                    <div className="row g-3 mb-3">
                      <div className="col-md-6">
                        <label
                          htmlFor="password"
                          className="form-label required"
                        >
                          Password
                        </label>
                        <input
                          type={isViewMode ? "text" : "text"}
                          className={`form-control p-2 ${
                            state.formSubmitted && !state.formData.password
                              ? "is-invalid"
                              : ""
                          }`}
                          id="password"
                          name="password"
                          value={state.formData.password}
                          onChange={handleInputChange}
                          required={state.formData.userId === 0}
                          readOnly={isViewMode}
                        />
                        {state.formSubmitted &&
                          !state.formData.password &&
                          state.formData.userId === 0 && (
                            <div className="invalid-feedback">
                              Password is required
                            </div>
                          )}
                        {isViewMode && (
                          <small className="text-muted">
                            Password is hidden for security
                          </small>
                        )}
                      </div>
                    </div>
                  )}

                  {/* Sixth Row - Status (conditional) */}
                  {state.formData.userId > 0 && (
                    <div className="row g-3 mb-3">
                      <div className="col-md-6">
                        <label htmlFor="isActive" className="form-label">
                          Status
                        </label>
                        <select
                          className="form-select"
                          id="isActive"
                          name="isActive"
                          defaultValue={state.formData.isActive}
                          onChange={handleInputChange}
                          disabled={isViewMode}
                        >
                          <option value={false}>Active</option>
                          <option value={true}>Inactive</option>
                        </select>
                      </div>
                    </div>
                  )}
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-bs-dismiss="modal"
                  id="usercloseModalLabel"
                >
                  Close
                </button>
                {!isViewMode && (
                  <button type="submit" className="btn btn-primary">
                    {state.formData.userId > 0 ? "Update" : "Submit"}
                  </button>
                )}
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
